var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Food",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8401",
    "data-name": "Rectangle 8401",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35264",
    "data-name": "Group 35264",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35908",
    "data-name": "Path 35908",
    d: "M15.913,9.537a5.782,5.782,0,0,0-6.928,1.539l2.5,2.5a.755.755,0,0,1,0,1.059.7.7,0,0,1-.962,0l-2.31-2.31L2.343,24.257a1.325,1.325,0,0,0,0,.866A1.106,1.106,0,0,0,3.69,25.6l6.062-2.983L7.539,20.407A.748.748,0,1,1,8.6,19.349l2.6,2.6,4.715-2.213a6.142,6.142,0,0,0,2.6-2.6,5.621,5.621,0,0,0-2.494-7.548l-.106-.052",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35909",
    "data-name": "Path 35909",
    d: "M20.146,7.9A4.5,4.5,0,0,0,18.7,2.32a4.52,4.52,0,0,0-.385,6.928l.385.385a4.619,4.619,0,0,0,6.53.167,4.548,4.548,0,0,0,.5-.552A4.719,4.719,0,0,0,20.143,7.9",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccFood);
export default __webpack_public_path__ + "static/media/mcc_food.fc9ad7aab51e56cd05d54857e006c0a8.svg";
export { ForwardRef as ReactComponent };